<template>
  <div class="page-sales">
    <div class="page-header">
      <el-menu
        :default-active.sync="activeIndex"
        class="el-menu-sales"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="/workshop/customers">Clientes</el-menu-item>
        <el-menu-item index="/workshop/receptions">Recepciones</el-menu-item>
        <el-menu-item index="/workshop/documents">Documentos</el-menu-item>
        <el-menu-item index="/workshop/test1">Test1</el-menu-item>
        <el-menu-item index="/workshop/repair">Repair</el-menu-item>
        <el-menu-item index="/workshop/test2">Test2</el-menu-item>
        <el-menu-item index="/workshop/qa">QA</el-menu-item>
        <el-menu-item index="/workshop/departures">Salidas</el-menu-item>
        <el-submenu index="2-4">
          <template slot="title">Mantenimientos</template>
          <el-menu-item index="/workshop/maintenances/countries"
            >Paises</el-menu-item
          >
          <el-menu-item index="/workshop/maintenances/reasons"
            >Razones</el-menu-item
          >
          <el-menu-item index="/workshop/maintenances/repair_ratio"
            >Relación de reparación</el-menu-item
          >
        </el-submenu>
        <el-submenu index="3-4">
          <template slot="title">Reportes</template>
          <el-menu-item index="/workshop/reports/ingenico"
            >Ingenico</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Workshop",
  data() {
    return {
      activeIndex: "/workshop/customers"
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleSelect(key, keyPath) {
      if (key.charAt(0) === "/") {
        this.$router.push(key);
        this.$emit("push-page", { page: key });
      }
    },
    setLink(path) {
      this.activeIndex = path;
    }
  },
  created() {
    if (this.$router.currentRoute.path === "/workshop") {
      this.handleSelect(this.activeIndex);
    }
    this.setLink(this.$router.currentRoute.path);
    // eslint-disable-next-line
    this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute.path);
    });
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
